module.exports = __webpack_public_path__ + "static/media/magnifier.e163de3f.svg";